<div class="d-flex outer-box">
  <!--This div will have padding from all sides-->
  <div class="d-flex flex-column inner-box">
    <span class="welcome-text">Welcome to</span>
    <span class="katalyst-title">Kinergy</span>
    <span class="username">{{firstName}}</span>
    <app-divider-line></app-divider-line>
    <div class="message-description">
      This is a modern and scalable platform that enhances usability, promotes collaboration, enables easy
      customization, and unlocks long-term growth possibilities. It is an all-in-one deal platform that marks
      significant change in how we deploy technology, using prebuilt and customizable utilities.
    </div>
    <button mat-flat-button class="large-btn continue-button margin-top-30" color="primary"
      (click)="saveUserPreference()">
      Continue
      <img src="assets/images/icons/direction-big-arrow.svg" alt="Next Arrow" />
    </button>
    <div class="d-flex flex-row margin-top-30">
      <mat-checkbox [checked]="getChecked()" (change)="toggleUserPreference()" class="checkbox-padding">
      </mat-checkbox>
      <p>Don't show this message next time</p>
    </div>
  </div>
</div>